import clsx from 'clsx';
import React from 'react';
import type {MenuItemProps} from '../Menu/MenuItem';
import {MenuItem} from '../Menu/MenuItem';
import {dropdownCssClassNames} from './dropdownCssClassNames';
import {useDropdownContext} from './hooks/useDropdownContext';

export interface DropdownItemProps extends MenuItemProps {
    /**
     * Block default closing animation
     */
    disableClose?: boolean;
}

export const DropdownItem = React.forwardRef<HTMLLIElement, DropdownItemProps>(({
    children, onClick, disableClose, className, ...props
}, ref) => {
    const {handleClose} = useDropdownContext('Menu');

    const handleOnClick: MenuItemProps['onClick'] = (event) => {
        onClick?.(event);

        if (!disableClose) {
            handleClose(event);
        }
    };

    return (
        <MenuItem
            className={clsx(
                dropdownCssClassNames.menuItem,
                className
            )}
            {...props}
            onClick={handleOnClick}
            ref={ref}
        >
            {children}
        </MenuItem>
    );
});

DropdownItem.displayName = 'DropdownItem';
